var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVideoCallRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "23px",
    viewBox: "0 0 34 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icVideoCallRed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP-CHAT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat-group-expanded-video-copy-7",
    transform: "translate(-265.000000, -29.000000)",
    fill: "#E83838",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(190.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.259831,3.66461074 C108.095423,3.60482095 107.937328,3.57480018 107.785413,3.57480018 C107.443837,3.57480018 107.159545,3.68884134 106.931673,3.91629429 L99.2854295,11.1399081 L99.2854295,8.17508968 C99.2854295,6.74938637 98.7510032,5.5306816 97.6821505,4.51834603 C96.6132315,3.50613632 95.3265413,3 93.8210168,3 L80.4641469,3 C78.9590875,3 77.6719987,3.50613632 76.6030131,4.51834603 C75.5344263,5.5306816 75,6.74938637 75,8.17508968 L75,20.8250991 C75,22.2506766 75.5344263,23.4693184 76.6030796,24.481591 C77.6720651,25.4938637 78.959154,26 80.4642133,26 L93.8211497,26 C95.3266078,26 96.6133644,25.4938637 97.6822835,24.481591 C98.7511361,23.4693184 99.2855624,22.2507395 99.2855624,20.8250991 L99.2855624,17.842092 L106.931806,25.0836428 C107.159678,25.3110328 107.44397,25.425011 107.785546,25.425011 C107.937461,25.425011 108.095556,25.3950532 108.259964,25.3353893 C108.753521,25.1316634 109,24.7784002 109,24.2752848 L109,4.72502989 C108.999801,4.22166279 108.753321,3.86833659 108.259831,3.66461074 Z",
    id: "icVideoCallRed",
    transform: "translate(92.000000, 14.500000) rotate(-360.000000) translate(-92.000000, -14.500000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoCallRed);
export default __webpack_public_path__ + "static/media/icVideoCallRed.134b129b4366ea3310f3d50998c4a06e.svg";
export { ForwardRef as ReactComponent };